<div class="process-version-label">
	<span class="process-version-name">{{ versionName }}</span>
	<i class="ico ico-valid-circle" *ngIf="validVersion"></i>
</div>
